import type { ReactNode } from 'react';
import styles from './PageShell.module.css';

export type PageWidth = 'narrow' | 'wide' | 'full' | 'map';

export interface PageShellProps {
  children: ReactNode;
  width?: PageWidth;
  header?: ReactNode;
  /** Full-width journey progress bar (e.g. map / assessment). */
  progress?: ReactNode;
}

export default function PageShell({ children, width = 'wide', header, progress }: PageShellProps) {
  const widthClass =
    width === 'narrow'
      ? styles.narrow
      : width === 'full'
        ? styles.full
        : width === 'map'
          ? styles.map
          : styles.wide;

  return (
    <div className={styles.page}>
      <div className={styles.body}>
        {progress ? <div className={styles.progress}>{progress}</div> : null}
        <div className={widthClass}>
          {header ? <div className={styles.header}>{header}</div> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
